module.exports = __webpack_public_path__ + "static/img/wode-b.ba29b75.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/wode-b.png
// module id = jIu6
// module chunks = 1